import styled from '@emotion/styled'

import {cssTheme} from '../../../themes'
import {NoStyleButton} from '../helpers/NoStyleButton'

export const FooterLink = styled.a`
  ${cssTheme.typography.bodyXS};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: ${cssTheme.colors.content.neutral.c700};
  }

  &:active {
    text-decoration: none;
    color: ${cssTheme.colors.content.neutral.c400};
  }

  &:focus-visible {
    outline: 1px solid ${cssTheme.colors.border.neutral.c600};
  }
`

export const FooterLinkButton = styled(NoStyleButton)`
  ${cssTheme.typography.bodyXS};

  &:hover {
    text-decoration: underline;
    color: ${cssTheme.colors.content.neutral.c700};
  }

  &:active {
    text-decoration: none;
    color: ${cssTheme.colors.content.neutral.c400};
  }

  &:focus-visible {
    outline: 1px solid ${cssTheme.colors.border.neutral.c600};
  }
`
